import Content from "./Content";

export default function AdminProjectPage() {
  return <Content />
} 